import { useTranslation } from 'react-i18next';

import { PaymentNameForm } from 'components/pages/Payment/PaymentNameForm';
import { PaymentStatus } from 'components/pages/Payment/PaymentStatus';
import { Button, Skeleton, Text, VStack } from 'components/uikit';
import { useFetchPayment } from 'data/payments/hooks';
import { resolve } from 'utils/remote';
import { useQueryParam } from 'utils/router/useQueryParam';

import { PaymentCredentials } from './PaymentCredentials';

export function PaymentPage() {
  const { t } = useTranslation('payments');

  const depositId = useQueryParam('depositId');
  const { paymentRemote, fetchPayment } = useFetchPayment(depositId);

  return (
    <VStack spacing='32px'>
      {resolve(paymentRemote, {
        LOADING: () => (
          <>
            <Skeleton w='500px' h='36px' />
            <Skeleton w='360px' h='52px' />
            <Skeleton w='360px' h='52px' />
          </>
        ),
        ERROR: () => (
          <>
            <Text as='h3' fontSize='2xl' fontWeight='medium' color='error.text'>
              {t('payment_fetching_error')}
            </Text>
            <Button
              w='360px'
              size='lg'
              variant='primary'
              onClick={fetchPayment}
            >
              {t('retry')}
            </Button>
          </>
        ),
        SUCCESS: (payment) =>
          payment.status !== 'CREATED' || payment.amount == null ? (
            <PaymentStatus
              status={payment.status}
              successRedirectLink={payment.successRedirect}
              failureRedirectLink={payment.failureRedirect}
            />
          ) : payment.credentials ? (
            <PaymentCredentials
              id={depositId}
              acquirer={payment.acquirer}
              method={payment.method}
              amount={payment.amount}
              currency={payment.currency}
              expiryDate={payment.expiryDate}
              credentials={payment.credentials}
              failureRedirectLink={payment.failureRedirect}
              customerId={payment.customerId}
            />
          ) : (
            <PaymentNameForm
              depositId={depositId}
              amount={payment.amount}
              expiryDate={payment.expiryDate}
            />
          ),
      })}
    </VStack>
  );
}
